import { AlertDialog } from './components/AlertDialogs';
import { CheatSheet } from './components/CheatSheet';
import { Dialogs } from './components/Dialogs';
import { LogsComponent } from './components/Logs';
import { MenuBar } from './components/MenuBar';
import {
  type LogbookConfig,
  NewLogbookWizard,
} from './components/NewLogbookWizard';
import { Tutorial } from './components/Tutorial';
import './index.css';
import {
  $assignment,
  $codeWords,
  $currentOperator,
  $date,
  $defaultFrequency,
  $myCallsign,
  $operators,
  $showWizard,
  closeNewLogbookWizard,
  syncServerState,
} from './stores';
import './stores/scheduledReminders';
import { IS_TAURI } from './utils/platformUtils';
import { useServerSync } from './utils/useServerSync';
import { useStore } from '@nanostores/react';
import { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';

export function App() {
  const showWizard = useStore($showWizard);
  useServerSync();

  useEffect(() => {
    if (IS_TAURI) {
      void syncServerState();
    }
  }, []);

  const handleWizardSave = (config: LogbookConfig) => {
    $assignment.set(config.assignment);
    $date.set(config.date);
    $myCallsign.set(config.myCallsign);
    $defaultFrequency.set(config.defaultFrequency);
    $operators.set(config.operators);
    $codeWords.set(config.codeWords);
    if (config.operators.length > 0) {
      $currentOperator.set(config.operators[0]!);
    }
  };

  return (
    <>
      <ToastContainer />
      <AlertDialog />
      {showWizard && (
        <NewLogbookWizard
          onClose={closeNewLogbookWizard}
          onSave={handleWizardSave}
        />
      )}
      <CheatSheet />
      <div className="flex flex-col overflow-hidden not-print:h-screen">
        <MenuBar />
        <Dialogs />
        <Tutorial />
        <LogsComponent />
      </div>
    </>
  );
}

export default App;
